<template>
  <v-container grid-list-lg class="pa-0 ma-0" fluid>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12 lg12 class="pt-0 pb-0">
        <v-card
          flat
          :style="
            !$vuetify.breakpoint.smAndDown
              ? 'padding-left: 30px; padding-right: 30px;'
              : 'padding-top: 15px; padding-bottom: 10px;'
          "
        >
          <v-card-title class="pt-0 pb-0">
            <v-layout
              row
              wrap
              :align-center="$vuetify.breakpoint.smAndUp"
              :align-content-center="$vuetify.breakpoint.smAndDown"
            >
              <v-flex xs12 sm3 md2 lg1 :style="!$vuetify.breakpoint.smAndDown ? 'margin-right: 10px;' : ''">
                <v-btn
                  color="primary"
                  round
                  :flat="!filtroAtivo"
                  :outline="!filtroAtivo"
                  :block="$vuetify.breakpoint.smAndDown"
                  @click="dialogFiltro = true"
                >FILTRO</v-btn>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12 lg12 class="pt-0 pb-0">
        <v-card
          flat
          :style="
            !$vuetify.breakpoint.smAndDown
              ? 'padding-left: 30px; padding-right: 30px;'
              : 'padding-top: 15px; padding-bottom: 10px;'
          "
        >
          <v-card-title class="pt-0 pb-0">
            <v-layout
              row
              wrap
              :align-center="$vuetify.breakpoint.smAndUp"
              :align-content-center="$vuetify.breakpoint.smAndDown"
            >
              <v-spacer></v-spacer>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>

    </v-layout>

    <div style="padding:30px 50px">
      <v-layout  row wrap>
        <v-flex
          xs4
          md2
          class="d-flex"
          style="align-items: center"
        >
          <h3 class="headline-1 mb-0"  style="font-size: 18px">Pedidos de Cotação</h3>
        </v-flex>
        <v-flex
          xs8
          md3
          offset-md7

          class="d-flex"
          style="justiy-content: right"
        >

            <v-btn class="secondary" @click="abrirDialogCotacao" round>
              Solicitar Cotação
            </v-btn>
        </v-flex>

      </v-layout>
      <template>
        <div>
          <v-data-table
            :headers="headers"
            :items="cotacaoList"
            hide-actions
            :rows-per-page-items="[10, 25, 50, 100]"
            rows-per-page-text="Linhas por página"
            :total-items="paginacao.totalItems"
            :pagination.sync="paginacao"
            item-key="item"
            no-data-text="Nenhum registro encontrado"
            class="elevation-1 table-grid grid-corretor-parceiro"
          >
            <template  v-slot:items="props">
              <td @click="abrirModalCorretorAnalista(props.item, props.item.idStatusCorretorReserva)" class="themeGrey--text click">
                {{ nomeEmpresaParceira(props.item) }}
              </td>
              <td @click="abrirModalCorretorAnalista(props.item, props.item.idStatusCorretorReserva)" class="themeGrey--text click">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ truncarTexto(nomeCorretorParceiro(props.item), 16) }}
                    </span>
                  </template>
                  <span style="margin-top: 50px">{{ nomeCorretorParceiro(props.item) }}</span>
                </v-tooltip>
              </td>
              <td class="themeGrey--text coluna-status-tratativa">
                <span class="coluna-status-tratativa__conteudo">
                  <span class="coluna-status-tratativa__icone">
                    <IconeChatTratativa
                      v-if="props.item.temTratativa"
                      :qtdNaoLidas="props.item.qtdNaoLidas || 0"
                      :notificacaoInformativa="!!props.item.notificacaoInformativa"
                      :titulo="tituloDoChat(props.item)"
                      @abrir="abrirModalTratativa(props.item)"
                    ></IconeChatTratativa>
                  </span>
                  <BolinhaStatusTratativa :cor="corDaBolinha(props.item)" />
                  <span
                    class="click"
                    @click="abrirModalCorretorAnalista(props.item, props.item.idStatusCorretorReserva)"
                  >{{ props.item.nomeStatusCorretorReserva }}</span>
                </span>
              </td>
              <td @click="abrirModalCorretorAnalista(props.item, props.item.idStatusCorretorReserva)" class="themeGrey--text click">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{formatarTecnicoResponsavel( props.item.nomeTecnicoResponsavel) }}
                    </span>
                  </template>
                  <span style="margin-top: 50px">{{ props.item.nomeTecnicoResponsavel }}</span>
                </v-tooltip>
              </td>
              <td @click="abrirModalCorretorAnalista(props.item, props.item.idStatusCorretorReserva)" class="themeGrey--text click">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ truncarTexto(props.item.razaoSocial, 20) }}
                    </span>
                  </template>
                  <span style="margin-top: 50px">{{ props.item.razaoSocial || "-" }}</span>
                </v-tooltip>
              </td>
              <td
                @click="abrirModalCorretorAnalista(props.item, props.item.idStatusCorretorReserva)"
                v-for="([texto, atributos], index) in colunas(props.item)"
                :key="index"
                v-bind="atributos"
                :class="[' themeGrey--text click', ...(atributos.class || [])]"
              >
                {{ texto }}
              </td>
              <td>
                <a
                  class="btn-dialog-historico"
                  @click="
                    abrirdialogHistorico(
                      props.item.idApolice,
                      props.item.apoliceNumeroProposta,
                      props.item.idStatusCorretorReserva
                    )
                  "
                >
                  Ver histórico
                </a>
              </td>
            </template>
          </v-data-table>
          <div class="datatable-footer-custom">
            <div class="datatable-footer-custom__perpage">
              <span class="datatable-footer-custom__label">Linhas por página:</span>
              <v-select
                :items="[10, 25, 50, 100]"
                v-model="paginacao.rowsPerPage"
                hide-details
                class="datatable-footer-custom__select"
              ></v-select>
            </div>
            <span class="datatable-footer-custom__range">{{ intervaloPaginaTexto }}</span>
            <v-btn
              icon
              flat
              :disabled="paginacao.page <= 1"
              @click="paginacao.page = 1"
            >
              <v-icon :color="paginacao.page <= 1 ? 'themeGrey' : 'primary'">first_page</v-icon>
            </v-btn>
            <v-btn
              icon
              flat
              :disabled="paginacao.page <= 1"
              @click="paginacao.page--"
            >
              <v-icon :color="paginacao.page <= 1 ? 'themeGrey' : 'primary'">chevron_left</v-icon>
            </v-btn>
            <v-btn
              icon
              flat
              :disabled="paginacao.page >= totalPaginas"
              @click="paginacao.page++"
            >
              <v-icon :color="paginacao.page >= totalPaginas ? 'themeGrey' : 'primary'">chevron_right</v-icon>
            </v-btn>
            <v-btn
              icon
              flat
              :disabled="paginacao.page >= totalPaginas"
              @click="paginacao.page = totalPaginas"
            >
              <v-icon :color="paginacao.page >= totalPaginas ? 'themeGrey' : 'primary'">last_page</v-icon>
            </v-btn>
          </div>
        </div>
      </template>
      <v-snackbar
        :timeout="3000"
        :color="snackbar.sucesso ? 'success' : 'error'"
        multi-line
        v-model="snackbar.visivel"
      >
        {{ snackbar.mensagem }}
        <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
      </v-snackbar>
      <template>
      <v-layout row justify-center>
        <v-dialog
          persistent
          v-model="dialogCotacao"
          max-width="336"
        >
          <ModalCotacao
            v-if="dialogCotacao"
            @fecharDialog="fechar"
            @voltarDialog="voltarDialogCotacao"
            @atualizar="atualizarGrid"
            :atualizarCorretoresProps="this.atualizar()"
            @fechar="dialogCotacao = false"
          />
        </v-dialog>
      </v-layout>
      </template>
      <template>
        <v-layout row justify-center>
          <v-dialog persistent v-model="dialogFiltro" max-width="900">
            <ModalFiltroCorretor
              v-if="dialogFiltro"
              :filtroInicial="filtroAtivo"
              :opcoesStatus="opcoesStatusFiltro"
              :opcoesTecnico="opcoesTecnicoFiltro"
              :opcoesCorretor="opcoesCorretorFiltro"
              :opcoesEmpresa="opcoesEmpresaFiltro"
              @filtrar="aplicarFiltro"
              @limpar="limparFiltro"
              @fechar="dialogFiltro = false"
            />
          </v-dialog>
        </v-layout>
      </template>
      <template>
      <v-layout row justify-center>
        <v-dialog
          persistent
          v-model="dialogCotacaoAnalista"
          max-width="876"
        >
          <ModalCotacaoAnalista
            v-if="dialogCotacaoAnalista"
            @fecharDialog="dialogCotacaoAnalista = false"
            :objetoCorretor="corretorReserva"
            @atualizar="recarregarLista"
            @tratativaAtualizada="atualizarResumoTratativas"
            :idStatusCorretor="idStatusClicado"
            :abrirEmTratativas="abrirModalNaAbaTratativas"
          />
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogHistorico" max-width="520px">
          <ModalHistorico
            v-if="dialogHistorico"
            :dialog="dialogHistorico"
            @fecharDialogHistorico="dialogHistorico = false"
            :numeroProposta="this.numeroPropostaHistorico"
            :idStatus="this.statusPropostaHistorico"
            :idApolice="this.idApoliceClick"
            :cotacao="true"
            scrollable
          />
        </v-dialog>
      </v-layout>
    </template>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import CustomFormat from "@/helpers/custom-format";
import usuarioHelper from "@/helpers/usuario-logado.js";
import ModalCotacaoAnalista from "./ModalCotacaoAnalista.vue";
import BolinhaStatusTratativa from "@/components/shared/BolinhaStatusTratativa.vue";
import ModalCotacao from "./ModalCotacao.vue";
import ModalHistorico from "../frota/ModalHistorico.vue";
import ModalFiltroCorretor from "./ModalFiltroCorretor.vue";
import IconeChatTratativa from "@/components/shared/IconeChatTratativa.vue";
import statusTratativa from "@/helpers/status-tratativa.js";

const DE_PARA_STATUS_CORRETOR_RESERVA = {
  1: 8,
  2: 8,
  3: 4,
  4: 6,
  5: 1,
  6: 7,
  7: 5,
  8: 9,
  9: 10,
  10: 12,
  11: 13,
  12: 14,
  13: 15,
  14: 16,
  15: 17
};

const INTERVALO_RESUMO_TRATATIVA = 60000;

export default {
  name: "GridSolicitacaoCotacao",
  components: {
    ModalCotacao,
    ModalCotacaoAnalista,
    BolinhaStatusTratativa,
    ModalHistorico,
    ModalFiltroCorretor,
    IconeChatTratativa
  },
  data() {
    return {
      corretorReserva: {
        dataVencimentoApolice: null,
        cnpj: null,
        idCiaRenovacao: null,
        razaoSocial: null,
        descricao:null,
        detentorApolice: null,
        idStatusCorretorReserva: null,
        usuario: [],
      },
      numeroReserva: null,
      dateInicio: new Date().toISOString().slice(0, 10),
      menu1: false,
      idUsuario: 1,
      cotacaoList: [],
      dialog: false,
      resposta: false,
      dialogErros: false,
      loading: false,
      selected: null,
      dialogHistorico: false,
      numeroPropostaHistorico: null,
      usuarioList: [],
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: ""
        },
        status: {
          opened: false,
          opcoes: [{id:0, titulo: "Todos"}],
          selecionado: null,
          selecionadoId: null,
        }
      },
      paginacao: {
        page: parseInt(sessionStorage.getItem('pageGridSolicitacaoCorretorReserva')) || 1,
        rowsPerPage: parseInt(sessionStorage.getItem('rowsPerPageGridSolicitacaoCorretorReserva')) || 10,
        totalItems: 0,
        sortBy: null,
        descending: false
      },
      headers: [
        { text: "EMPRESA PARCEIRA", align: "left", value: "grupoUsuario", sortable: false, width: "10%" },
        { text: "CORRETOR PARCEIRO", align: "left", value: "nomeUsuario", sortable: false, width: "12%" },
        { text: "STATUS DA COTAÇÃO", align: "left", value: "nomeStatusCorretorReserva", sortable: false, width: "11%" },
        { text: "TÉCNICO RESPONSÁVEL", align: "left", value: "nomeTecnicoResponsavel", sortable: false, width: "11%" },
        { text: "RAZÃO SOCIAL DO SEGURADO", align: "left", value: "razaoSocial", sortable: false, width: "14%" },
        { text: "CNPJ/CPF", align: "left", value: "cnpj", sortable: false, width: "10%" },
        { text: "N. RESERVA", align: "left", value: "numeroReserva", sortable: false, width: "8%" },
        { text: "DATA DA SOLICITAÇÃO", align: "left", value: "dataCriacao", sortable: false, width: "8%" },
        { text: "VIGÊNCIA SEGURO", align: "left", value: "dataVencimentoApolice", sortable: false, width: "8%" },
        { text: "HISTÓRICO DE STATUS", align: "left", value: "historico", sortable: false, width: "8%" }
      ],
      dialogCotacao: false,
      dialogCotacaoAnalista: false,
      dialogFiltro: false,
      filtroAtivo: null,
      opcoesStatusFiltro: [],
      opcoesTecnicoFiltro: [],
      opcoesCorretorFiltro: [],
      opcoesEmpresaFiltro: [],
      idCorretorSalvo: null,
      idStatusClicado: null,
      abrirModalNaAbaTratativas: false,
      intervaloResumoTratativa: null,
      snackbar: {
        visivel: false,
        sucesso: false,
        mensagem: ""
      }
    };
  },

  computed: {
    filtroComputed: function() {
      const self = this;
      return {
        filtroStatusString: function() {
          if (self.filtro.status.selecionado) {
            return self.filtro.status.selecionado;
          } else {
            return "Status";
          }
        },
        statusSelecionadoDescricaoString: function() {
          if (self.filtro.status.selecionado) {
            return self.filtro.status.selecionado;
          } else {
            return "";
          }
        }
      };
    },
    customFormatComputed: function() {
      return CustomFormat;
    },
    idPerfilLogado: function() {
      const usuario = usuarioHelper.USUARIO_LOGADO();
      return usuario && usuario.perfil ? usuario.perfil.id : null;
    },
    totalPaginas: function() {
      return Math.max(
        1,
        Math.ceil(this.paginacao.totalItems / this.paginacao.rowsPerPage)
      );
    },
    intervaloPaginaTexto: function() {
      const total = this.paginacao.totalItems;
      if (total === 0) {
        return "0 de 0";
      }
      const inicio = (this.paginacao.page - 1) * this.paginacao.rowsPerPage + 1;
      const fim = Math.min(
        this.paginacao.page * this.paginacao.rowsPerPage,
        total
      );
      return `${inicio}-${fim} de ${total}`;
    }
  },
  watch: {
    "paginacao.page"(val) {
      sessionStorage.setItem("pageGridSolicitacaoCorretorReserva", val);
      this.recarregarLista();
    },
    "paginacao.rowsPerPage"(val) {
      sessionStorage.setItem("rowsPerPageGridSolicitacaoCorretorReserva", val);
      this.recarregarLista();
    },
    "idCorretorSalvo"() {
      this.buscarCorretores()
    }

  },
  mounted() {
    this.$store.commit("formCorretorReserva/limparTudo");

    const filtroSalvo = sessionStorage.getItem("filtroGridSolicitacaoCorretorReserva");
    if (filtroSalvo) {
      try {
        this.filtroAtivo = JSON.parse(filtroSalvo);
      } catch (e) {
        this.filtroAtivo = null;
        sessionStorage.removeItem("filtroGridSolicitacaoCorretorReserva");
      }
    }

    this.recarregarLista();
    this.getListStatus();
    this.getOpcoesFiltro();
    this.iniciarResumoTratativas();
  },

  beforeDestroy() {
    this.pararResumoTratativas();
  },

  methods: {

    getListStatus() {
      axios
        .get(
          `${process.env.URL_CORRETORMS}/v1/statusCorretorReserva`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          const lista = response.data instanceof Array ? response.data : [];
          lista.forEach(element => {
            this.filtro.status.opcoes.push(element);
          });
          this.opcoesStatusFiltro = lista;
        })
        .catch(err => {
          this.snackbar.color = "error";
          this.snackbar.visivel = true;
          this.snackbar.mensagem = "Nenhum resultado encontrado";
        });
    },
    getOpcoesFiltro() {
      axios
        .get(`${process.env.URL_CORRETORMS}/v1/opcoesFiltroCorretorReserva`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          const dados = response.data || {};
          this.opcoesTecnicoFiltro = Array.isArray(dados.tecnicos) ? dados.tecnicos : [];
          this.opcoesCorretorFiltro = Array.isArray(dados.corretores) ? dados.corretores : [];
          this.opcoesEmpresaFiltro = Array.isArray(dados.empresas) ? dados.empresas : [];
        })
        .catch(() => {
          this.opcoesTecnicoFiltro = [];
          this.opcoesCorretorFiltro = [];
          this.opcoesEmpresaFiltro = [];
        });
    },
    formatarTecnicoResponsavel(nome) {
      if(nome != null) {
        if(nome.length > 16) {
          return nome.substring(0, 17).concat("...")
        }else {
          return nome
        }
      } else {
        return " ";
      }
    },
    atualizar(corretor) {
      if(corretor) {
        this.idCorretorSalvo = corretor.id
        this.buscarCorretores()
      }
    },
    abrirDialogCotacao() {
      this.$store.commit("formCorretorReserva/limparTudo");
      this.dialogCotacao = true;
    },

    voltarDialogCotacao() {
      this.dialogCotacao = true;
    },
    resetFiltros() {
      this.filtro.status.selecionado = null;
      this.filtro.status.selecionadoId = null;
      this.filtro.pesquisa.conteudo = null;

    },
    verificaPerfilUsuario() {
      if(usuarioHelper.USUARIO_LOGADO().perfil.id == 1 || usuarioHelper.USUARIO_LOGADO().perfil.id == 2 || usuarioHelper.USUARIO_LOGADO().perfil.id == 3 || usuarioHelper.USUARIO_LOGADO().perfil.id == 4 || usuarioHelper.USUARIO_LOGADO().perfil.id == 5 || usuarioHelper.USUARIO_LOGADO().perfil.id == 6 || usuarioHelper.USUARIO_LOGADO().perfil.id == 7 || usuarioHelper.USUARIO_LOGADO().perfil.id == 8) {
        return true;
      } else {
        return false;
      }

    },

    abrirdialogHistoricoErro(id) {
      if (id) {
        this.numeroPropostaHistoricoErro = id;
      } else {
        this.numeroPropostaHistoricoErro = "0";
      }
      this.dialogErros = true;
    },

    abrirdialogHistorico(id, numeroProposta, statusProposta) {
      if (numeroProposta) {
        this.numeroPropostaHistorico = numeroProposta.toString();
      } else {
        this.numeroPropostaHistorico = "0";
      }
      if (id) {
        this.idApoliceClick = id;
      } else {
        this.idApoliceClick = 0;
      }
      this.statusPropostaHistorico = statusProposta;
      this.dialogHistorico = true;
    },

    fecharDialogHistorico() {
      this.dialogHistorico = false;
    },

    fecharDialogHistoricoErro() {
      this.dialogErros = false;
    },
    recarregarLista() {
      if (this.filtroAtivo) {
        this.filtrarCorretores();
      } else {
        this.buscarCorretores();
      }
    },
    aplicarRetornoPaginado(dados) {
      this.cotacaoList = dados;
      if (dados.length) {
        this.paginacao.totalItems = dados[0].totalElements;
        this.atualizarResumoTratativas();
        return;
      }
      this.paginacao.totalItems = 0;
      if (this.paginacao.page > 1) {
        this.paginacao.page = 1;
      }
    },
    buscarCorretores() {
      this.$store.commit("startLoading");
      axios
        .get(
          `${process.env.URL_CORRETORMS}/v1/buscarSolicitacoesCorretorReserva?page=${this.paginacao
            .page - 1}&size=${this.paginacao.rowsPerPage}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.aplicarRetornoPaginado(response.data);
        })
        .catch(err => {
          this.cotacaoList = [];
          this.paginacao.totalItems = 0;
          this.snackbar.color = "error";
          this.snackbar.visivel = true;
          this.snackbar.mensagem = "Nenhum resultado encontrado";
        })
        .finally(() => {
          this.$store.commit("endLoading");
        });
    },
    aplicarFiltro(filtro) {
      this.filtroAtivo = filtro;
      sessionStorage.setItem("filtroGridSolicitacaoCorretorReserva", JSON.stringify(filtro));
      this.dialogFiltro = false;
      if (this.paginacao.page !== 1) {
        this.paginacao.page = 1;
      } else {
        this.filtrarCorretores();
      }
    },
    limparFiltro() {
      this.filtroAtivo = null;
      sessionStorage.removeItem("filtroGridSolicitacaoCorretorReserva");
      this.dialogFiltro = false;
      this.filtro.pesquisa.conteudo = "";
      if (this.paginacao.page !== 1) {
        this.paginacao.page = 1;
      } else {
        this.buscarCorretores();
      }
    },
    filtrarCorretores() {
      this.$store.commit("startLoading");
      axios
        .post(
          `${process.env.URL_CORRETORMS}/v1/filtrarCorretorReserva?page=${this.paginacao.page - 1}&size=${this.paginacao.rowsPerPage}`,
          this.filtroAtivo,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.aplicarRetornoPaginado(response.data);
        })
        .catch(() => {
          this.cotacaoList = [];
          this.paginacao.totalItems = 0;
          this.snackbar.color = "error";
          this.snackbar.visivel = true;
          this.snackbar.mensagem = "Nenhum resultado encontrado";
        })
        .finally(() => {
          this.$store.commit("endLoading");
        });
    },

    fechar() {
      this.$emit("fechar")
    },


    camposDisabled() {
      return this.idPropostaStatus > 1;
    },

    formatarData(data) {
      if (data) {
        return new Date(data).toLocaleDateString("pt-BR", {
          timeZone: "UTC",
          year: "numeric",
          month: "numeric",
          day: "numeric"
        });
      }
    },
    filtroFunctions: function() {
      const self = this;
      return {
        abrirFiltroPesquisa: function() {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function() {
          if (
            !self.filtro.pesquisa.conteudo ||
            self.filtro.pesquisa.conteudo == ""
          ) {
            self.filtro.pesquisa.opened = false;
          }
        }
      };
    },
    formatarCnpj(cnpj) {
      if (typeof cnpj === "string" && cnpj.match(/^[A-Za-z0-9]{12}\d{2}$/)) {
        return cnpj.replace(
          /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
          "$1.$2.$3/$4-$5"
        )
      }else if(typeof cnpj === "string" && cnpj.match(/^\d{11}$/)){
        return cnpj.replace(
          /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
          "$1.$2.$3-$4"
        )
      }
      return "";
    },
    buscarListaCia () {
      axios.get(`${process.env.URL_CORRETORMS}/v1/ciaRenovacao`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.ciaRenovacaoList =
            response.data instanceof Array ? response.data : [];
        })
        .catch(err => {
          console.error(err);
        });
    },
    formatMoney(amount) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(amount || 0);
    },

    formatarNumeroCotacao(item) {
      const numero = `000000${item}`;
      return numero.slice(numero.length - 6);
    },

    toLocaleString: function(datetime) {
      return CustomFormat.toLocaleDateTimeString(datetime);
    },

    atualizarGrid(){
      this.dialogCotacao = false;
      this.recarregarLista();
    },

    nomeEmpresaParceira(item) {
      const grupos = item.usuario ? item.usuario.grupos : null;
      if (grupos && grupos.length && grupos[0]) {
        return grupos[0].nome;
      }
      return "-";
    },

    nomeCorretorParceiro(item) {
      if (item.usuario && item.usuario.nome) {
        return item.usuario.nome;
      }
      return "-";
    },

    truncarTexto(texto, limite) {
      if (!texto) {
        return "-";
      }
      return texto.length > limite
        ? texto.substring(0, limite + 1).concat("...")
        : texto;
    },

    colunas(item) {
      return [
        [this.formatarCnpj(item.cnpj), {}],
        [item.numeroReserva, {}],
        [this.formatarData(item.dataCriacao), {}],
        [this.formatarData(item.dataVencimentoApolice), {}]
      ];
    },
    abrirModalCorretorAnalista (row, idStatusCorretorReserva) {
      this.corretorReserva = row;
      this.abrirModalNaAbaTratativas = false;
      this.dialogCotacaoAnalista = true;
      this.idStatusClicado = idStatusCorretorReserva;
    },
    abrirModalTratativa(row) {
      this.corretorReserva = row;
      this.abrirModalNaAbaTratativas = true;
      this.dialogCotacaoAnalista = true;
      this.idStatusClicado = row.idStatusCorretorReserva;
    },
    idPropostaStatusDaLinha(item) {
      if (item.idPropostaStatusTratativa) {
        return item.idPropostaStatusTratativa;
      }
      return DE_PARA_STATUS_CORRETOR_RESERVA[item.idStatusCorretorReserva] || null;
    },
    tituloDoChat(item) {
      const rotulo = statusTratativa.rotuloStatus(
        this.idPropostaStatusDaLinha(item),
        this.idPerfilLogado
      );
      return rotulo ? `Tratativa - ${rotulo}` : "Tratativa";
    },
    corDaBolinha(item) {
      if (!item.temTratativa) return "";
      return statusTratativa.corStatus(
        this.idPropostaStatusDaLinha(item),
        this.idPerfilLogado
      );
    },
    iniciarResumoTratativas() {
      this.pararResumoTratativas();
      this.intervaloResumoTratativa = setInterval(() => {
        if (document.hidden === false) {
          this.atualizarResumoTratativas();
        }
      }, INTERVALO_RESUMO_TRATATIVA);
    },
    pararResumoTratativas() {
      if (this.intervaloResumoTratativa) {
        clearInterval(this.intervaloResumoTratativa);
        this.intervaloResumoTratativa = null;
      }
    },
    atualizarResumoTratativas() {
      const ids = this.cotacaoList
        .map(item => item.id)
        .filter(id => id != null);
      if (!ids.length) {
        return;
      }
      axios
        .post(
          `${process.env.URL_TRATATIVAMS}/v1/resumo`,
          { idsCorretorReserva: ids },
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.aplicarResumoTratativas(
            response.data instanceof Array ? response.data : []
          );
        })
        .catch(() => {});
    },
    aplicarResumoTratativas(resumos) {
      resumos.forEach(resumo => {
        const linha = this.cotacaoList.filter(
          item => item.id === resumo.idCorretorReserva
        )[0];
        if (!linha) {
          return;
        }
        this.$set(linha, "temTratativa", true);
        this.$set(linha, "qtdNaoLidas", resumo.qtdNaoLidas || 0);
        this.$set(linha, "notificacaoInformativa", !!resumo.notificacaoInformativa);
        if (resumo.idPropostaStatus) {
          this.$set(linha, "idPropostaStatusTratativa", resumo.idPropostaStatus);
        }
      });
    },
    formatNomeTecnicoResponsavel(nome) {
      if(nome == null) {
        return ""
      } else if(nome.length > 16)  {
        return nome.substring(0, 17).concat("...")
      } else {
        return nome
      }
    }

  }
};
</script>

<style>
.datatable-footer-custom {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  padding: 6px 16px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}

.datatable-footer-custom__perpage {
  display: flex;
  align-items: center;
  margin-right: 32px;
}

.datatable-footer-custom__label {
  margin-right: 12px;
}

.datatable-footer-custom__select {
  width: 56px;
  margin: 0;
  padding: 0;
}

.datatable-footer-custom__range {
  margin-right: 24px;
}

.table-grid thead {
  background-color: #00456e;
}
.table-grid .column {
  color: #fff !important;
}

.table-grid th i {
  color: #fff !important;
}

.dialog {
  background: #eaeaea !important;
}

.headline {
  color: #fff;
  font-size: 14px !important;
}

.text-error {
  color: #f45353;
  font-weight: bold;
}

.name-arquivo {
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 10px 10px;
  background-color: #fff;
  border-radius: 2px;
}

input[type="file"] {
  display: none;
}

.button-custom {
  width: 100%;
  max-width: 121px;
  text-align: center;
  color: #fff !important;
  background-color: #00456e;
  border-radius: 2px;
  display: inline-block;
  padding: 9px 12px;
  cursor: pointer;

  font-weight: bold;
}

.button-custom:hover {
  background-color: #063f57;
}

.disabled,
.v-btn.button-custom:disabled {
  cursor: default;
  background-color: #063f57;
  color: #aaaaaa !important;
}

.disabled:hover {
  background-color: #063f57;
}

.click {
  cursor: pointer;
}
.size {
  size: 1;
}
.btn-dialog-historico {
  border: 0;
  background-color: transparent ;
  text-transform: uppercase ;
  text-align: center ;
  color: #027DB4 ;
  box-shadow: none ;

}
.btn-dialog-historico:hover {
  text-decoration:underline;

}

.btn-dialog-historico-erro {
  border: 0;
  background-color: transparent;
  text-transform: uppercase;
  text-align: center;
  color: #027db4;
  box-shadow: none;
}
.btn-dialog-historico-erro:hover {
  text-decoration: underline;
}
.table-grid thead th {
    white-space: normal!important;
    padding-right: 24px;
}
.table-grid thead td:not(:nth-child(1)),
.table-grid tbody td:not(:nth-child(1)),
.table-grid thead th:not(:nth-child(1)),
.table-grid tbody th:not(:nth-child(1)),
.table-grid thead td:first-child,
.table-grid tbody td:first-child,
.table-grid thead th:first-child,
.table-grid tbody th:first-child {
  padding: 0 12px!important;
}

.table-grid.grid-corretor-parceiro tbody td {
  padding: 0 12px !important;
  text-align: left !important;
  vertical-align: middle;
}

.table-grid.grid-corretor-parceiro thead tr:not(.v-datatable__progress) th {
  padding: 0 28px 0 12px !important;
  text-align: left !important;
  white-space: normal !important;
}

.table-grid.grid-corretor-parceiro thead th.column.sortable {
  position: relative;
}

.table-grid.grid-corretor-parceiro thead th.column .v-icon {
  position: absolute !important;
  top: 19px;
  right: 3px;
  width: 20px;
  height: 20px;
  margin: 0;
}

.coluna-status-tratativa {
  white-space: nowrap;
  text-align: left;
}

.coluna-status-tratativa__conteudo {
  display: inline-flex;
  align-items: center;
}

.coluna-status-tratativa__icone {
  flex: 0 0 46px;
  width: 46px;
  height: 36px;
}

.table-grid.grid-corretor-parceiro table {
  min-width: 1180px;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/corretor-reserva/GridSolicitacaoCotacao.vue